export default __webpack_public_path__ + "static/media/Beard_1_C5.a2c35f37.svg";